"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitsWith = void 0;
var React = __importStar(require("react"));
exports.limitsWith = {
    mobile: { min: 0, max: 671 },
    tablet: { min: 672, max: 1023 },
    desktop: { min: 1024, max: 99999 },
};
function Responsive(_a) {
    var displays = _a.displays, children = _a.children;
    var _b = React.useState({
        height: window.innerHeight,
        width: window.innerWidth,
    }), dimensions = _b[0], setDimensions = _b[1];
    React.useEffect(function () {
        function handleReSize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }
        window.addEventListener("resize", handleReSize);
        return function () {
            window.removeEventListener("resize", handleReSize);
        };
    });
    var renderChildren = false;
    displays.forEach(function (display) {
        if (!renderChildren &&
            exports.limitsWith[display].min <= dimensions.width &&
            dimensions.width <= exports.limitsWith[display].max) {
            renderChildren = true;
        }
    });
    return React.createElement(React.Fragment, null, renderChildren && children);
}
exports.default = Responsive;
//# sourceMappingURL=index.js.map